<template>
  <BackButtonInstitucional />
  <div class="row q-mt-md">
    <div class="col-md-5">
      <div class="row">
        <div class="col-6">
          <c-readonly-field
            title="Cadastro Institucional"
            :description="institutionalStore.institutionalDetail?.nome"
          />
        </div>
        <div class="col">
          <c-readonly-field
            title="Total"
            :description="distribuicao.totalPcs ?? 0"
            descriptionColor="globalBlue006BA7"
          />
        </div>
      </div>
      <div class="row q-mt-sm">
        <div class="col-6">
          <c-readonly-field
            title="Última atualização"
            :description="
              distribuicao.ultimaAtualizacao
                ? new Date(distribuicao.ultimaAtualizacao).toLocaleString()
                : ''
            "
          />
        </div>
        <div class="col">
          <c-readonly-field
            title="Sucesso"
            :description="distribuicao.totalSucesso ?? 0"
            descriptionColor="globalGreen17B51C"
          />
        </div>
        <div class="col">
          <c-readonly-field
            title="Pendente"
            :description="distribuicao.totalPendentes ?? 0"
            descriptionColor="globalOrangeFF6B00"
          />
        </div>
      </div>
    </div>

    <div class="col offset-md-4">
      <div class="row fit items-top">
        <div class="q-pr-xl q-mr-xl">
          <InstitutionalDevicesDistributionSection
          :pcsPorGrupo="institutionalStore.institutionalDetail?.pcsPorGrupo"
           :pcs="allPcs"
/>
        </div>
      </div>
    </div>
  </div>

  <c-q-separator class="q-my-lg" />

  <div class="row q-pb-lg">
    <div class="q-pb-xs">
      <span class="midia-app-label-lg">Pesquise um Dispositivo</span>
    </div>
    <div class="col-12" style="padding-right: 100px">
      <div class="row fit no-wrap justify-between items-end content-start">
        <div class="col-grow" style="overflow: auto">
          <q-input
            v-model="filterPc"
            color="globalAppPrimaryColor"
            bg-color="globalAppDefaultBackgroundColor"
            outlined
            dense
            placeholder="Busque um dispositivo"
            input-class="midia-app-content-lg"
            @update:model-value="searchPcs"
            @keyup.enter="searchPcs"
          >
            <template v-slot:prepend>
              <q-icon
                name="search"
                class="q-pa-sm"
                style="
                  background: var(--globalAppSecondaryColor4);
                  padding: 6px;
                  position: relative;
                  left: -11px;
                  border-right: 1px solid var(--globalAppSecondaryColor2);
                "
              />
            </template>
          </q-input>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12" style="padding-right: 100px">
      
<q-table
  :rows="filteredPcs"
  row-key="pc"
  :columns="columns"
  :visible-columns="visibleColumns"
  v-model:pagination="pagination.quasarPagination"
  :rows-per-page-options="[10, 50, 100, 300, 500]"
  @update:pagination="updatePagination"


        no-data-label="Nenhum registro encontrado!"
        rows-per-page-label="Linhas por página:"
        dense
        flat
        separator="horizontal"
        class="midia-app-table q-mt-md"
      >
        <template v-slot:header="props">
          <q-tr :props="props" style="background-color: var(--globalGrayF8F7F7) !important">
            <q-th
              v-for="col in props.cols"
              :key="col.field"
              :props="props"
              style="border: 0; padding: 2px"
            >
              <span class="midia-app-title-header-table-lg">{{ col.label }}</span>
            </q-th>
          </q-tr>
        </template>

        <template v-slot:body="props">
          <q-tr class="table-body-rows" :props="props">
            <q-td key="pc" :props="props" style="padding: 2px">
              <span class="midia-app-label-sm">{{ props.row.pc }}</span>
            </q-td>
            <q-td key="nome" :props="props" style="padding: 2px">
              <span class="midia-app-label-sm">{{ props.row.nome }}</span>
            </q-td>
            <q-td key="status" :props="props" style="padding: 2px">
              <span
                class="midia-app-label-sm"
                :style="'Sucesso' === props.row.status
                  ? 'color: var(--globalGreen17B51C)'
                  : 'color: var(--globalBlue28A5FF)'"
              >{{ props.row.status }}</span>
            </q-td>
            <q-td key="motivo" :props="props" style="padding: 2px">
              <span
                class="midia-app-label-sm"
                :style="'Coleta Pendente' === props.row.motivo
                  ? 'color: var(--globalBlue28A5FF)'
                  : 'color: var(--globalGreen17B51C)'"
              >{{ props.row.motivo }}</span>
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

import BackButtonInstitucional from '@/components/BackButtonInstitucional.vue'
import InstitutionalDevicesDistributionSection from '@/components/telasInstitucionais/InstitutionalDevicesDistributionSection.vue'

import { useInstitutionalStore } from '@/stores/institutionalStore'
import { usePagesUtilStore } from '@/stores/pagesUtilStore'
import messages from '@/utils/messages'
import type { QTableProps } from 'quasar'

const institutionalStore = useInstitutionalStore()
const pagesUtilStore = usePagesUtilStore()
const router = useRouter()
const isUpdatingFromBackend = ref(false)

/* =====================
 * COLUNAS
 * ===================== */
const columns = [
  { name: 'pc',     label: 'Código PC', field: 'pc',     align: 'center' as const },
  { name: 'nome',   label: 'Nome PC',   field: 'nome',   align: 'left'   as const },
  { name: 'status', label: 'Status',    field: 'status', align: 'left'   as const },
  { name: 'motivo', label: 'Motivo',    field: 'motivo', align: 'left'   as const }
]
const visibleColumns = ref(['pc', 'nome', 'status', 'motivo'])
const isInitialLoad = ref(true)

/* =====================
 * ESTADO
 * ===================== */
const distribuicao = ref<any>({
  totalPcs: 0,
  totalSucesso: 0,
  totalPendentes: 0,
  ultimaAtualizacao: null,
  totalPcPages: 0,
  currentPcPage: 0
})

const blockPagination = ref(true)


const allPcs      = ref<any[]>([])
const filteredPcs = ref<any[]>([])
const filterPc    = ref('')
//const blockPagination = ref(true)

const pagination = ref({
  currentPage: 0,
  totalPages: 0,
  quasarPagination: { page: 1, rowsPerPage: 10 }
})


/* =====================
 * FETCH PAGINADO
 * ===================== */
/*const fetchDistribuicao = async (telaId: number, page: number) => {
  pagesUtilStore.showLoading = true
  try {
    const response = await institutionalStore.fetchPcsDistribuicao(telaId, page, 100)

    if (response) {
      // ✅ atualiza totalizadores apenas na primeira página
      if (page === 0) {
        distribuicao.value = {
          totalPcs:          response.totalPcs          ?? 0,
          totalSucesso:      response.totalSucesso      ?? 0,
          totalPendentes:    response.totalPendentes    ?? 0,
          ultimaAtualizacao: response.ultimaAtualizacao ?? null,
          totalPcPages:      response.totalPcPages      ?? 0,
          currentPcPage:     response.currentPcPage     ?? 0
        }
        allPcs.value = [...(response.pcsTela || [])]
      } else {
        // ✅ acumula páginas seguintes
        allPcs.value.push(...(response.pcsTela || []))
        distribuicao.value.currentPcPage = response.currentPcPage ?? page
      }

      filteredPcs.value = [...allPcs.value]
      pagination.value.currentPage = response.currentPcPage ?? page
      pagination.value.totalPages  = response.totalPcPages  ?? 0
    }
  } catch (error) {
    messages.showErrorMsg('Erro ao buscar distribuição.')
  } finally {
    pagesUtilStore.showLoading = false
  }
}*/

const fetchDistribuicao = async (telaId: number, page: number) => {
  pagesUtilStore.showLoading = true

  try {
    // ✅ não pega mais retorno
    await institutionalStore.fetchPcsDistribuicao(telaId, page)

    const dist = institutionalStore.distribuicao

    if (dist && dist.pcsTela) {

      // ✅ agora vem do store
      allPcs.value = [...dist.pcsTela]
      filteredPcs.value = [...allPcs.value]

      distribuicao.value = {
        totalPcs: dist.totalPcs ?? 0,
        totalSucesso: dist.totalSucesso ?? 0,
        totalPendentes: dist.totalPendentes ?? 0,
        ultimaAtualizacao: dist.ultimaAtualizacao ?? null,
        totalPcPages: dist.totalPcPages ?? 0,
        currentPcPage: dist.currentPcPage ?? 0
      }

      pagination.value.currentPage = dist.currentPcPage ?? 0
      pagination.value.totalPages = dist.totalPcPages ?? 0
    }

  } catch (error) {
    messages.showErrorMsg('Erro ao buscar distribuição.')
  } finally {
    pagesUtilStore.showLoading = false
  }
}

/* =====================
 * LIFECYCLE
 * ===================== */
/*onMounted(async () => {
  const id = institutionalStore.institutionalDetail?.id
  if (!id) {
    messages.showErrorMsg('Cadastro não encontrado. Redirecionando...')
    router.push({ name: 'home' })
    return
  }
  await fetchDistribuicao(id, 0)
})*/


onMounted(async () => {
  const id = institutionalStore.institutionalDetail?.id

  if (!id) {
    messages.showErrorMsg('Cadastro não encontrado.')
    router.push({ name: 'home' })
    return
  }

  await fetchDistribuicao(id, 0)
})

/* =====================
 * BUSCA LOCAL
 * ===================== */
const searchPcs = () => {
  if (!filterPc.value) {
    filteredPcs.value = [...allPcs.value]
    return
  }
  const q = filterPc.value.toLowerCase()
  filteredPcs.value = allPcs.value.filter(pc =>
    pc?.pc?.toString().toLowerCase().includes(q) ||
    pc?.nome?.toLowerCase().includes(q)           ||
    pc?.status?.toLowerCase().includes(q)         ||
    pc?.motivo?.toLowerCase().includes(q)
  )
}

/* =====================
 * PAGINAÇÃO
 * ===================== */
/*const updatePagination = async (newPagination: object) => {
  if (newPagination && blockPagination.value) {
    blockPagination.value = false
    return
  }

  const visto = pagination.value.quasarPagination.rowsPerPage * pagination.value.quasarPagination.page
  const total = allPcs.value.length

  if (visto > 0 && total > 0 && visto >= total - 1) {
    const id = institutionalStore.institutionalDetail?.id
    if (id && pagination.value.currentPage < pagination.value.totalPages - 1) {
      await fetchDistribuicao(id, pagination.value.currentPage + 1)
    }
  }
}*/
const updatePagination = async (newPagination: any) => {

  if (newPagination && blockPagination.value) {
    blockPagination.value = false
    return
  }

  const total = filteredPcs.value.length

  const vistos =
    pagination.value.quasarPagination.rowsPerPage *
    pagination.value.quasarPagination.page

  if (vistos > 0 && total > 0 && vistos >= total - 1) {

    const id = institutionalStore.institutionalDetail?.id

    if (
      id &&
      pagination.value.currentPage < pagination.value.totalPages - 1
    ) {
      await fetchDistribuicao(id, pagination.value.currentPage + 1)
    }
  }
}
</script>

<style scoped></style>
